import React, { useCallback, useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useNotificationContext } from '@src/components/molecules/notification-context';
import { ResetForm } from '@src/components/organisms/login-modal/reset-form';
import { useResetPasswordMutation } from '@src/store/queries/auth';
import { NOTIFICATION_TYPES } from '@src/utils/constants';

import { StyledResetPasswordPage } from './styles';

const ResetPasswordPage = () => {
  const notificationApi = useNotificationContext();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const id = params.get('id');

  const [resetPassword] = useResetPasswordMutation();
  const [isLoading, setIsLoading] = useState(false);

  const handleOnReset = useCallback(
    async (data) => {
      setIsLoading(true);

      try {
        await resetPassword(data).unwrap();
        navigate('/?login=true');
        notificationApi[NOTIFICATION_TYPES.success]({
          message: 'Your password has been successfully reset. Please sign in with your new password.',
          pauseOnHover: true,
        });
      } catch {
        notificationApi[NOTIFICATION_TYPES.error]({
          message: 'An error occurred while processing your request. Please try again later.',
          pauseOnHover: true,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [resetPassword, navigate, notificationApi],
  );

  return (
    <StyledResetPasswordPage>
      <div className="reset-password-page">
        <div className="reset-password-page__container">
          <ResetForm token={token} id={id} onReset={handleOnReset} loading={isLoading} />
        </div>
      </div>
    </StyledResetPasswordPage>
  );
};

export default ResetPasswordPage;
